export default __webpack_public_path__ + "static/runn-ea4a97f2d270a8658999b9c3512263d4.png";